export default __webpack_public_path__ + "static/media/bg-circle-chain.c5b835bd.png";